export default "__VITE_ASSET__DAPybPtb__"